import { dispatch } from '@@/store';
// tslint:disable-next-line
import _ from 'lodash';
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
export function isUrl(path) {
    return reg.test(path);
}
export function urlToList(url) {
    const urllist = url.split('/').filter(i => i);
    return urllist.map((urlItem, index) => `/${urllist.slice(0, index + 1).join('/')}`);
}
export function changeRespToRawMenu(data) {
    const menuList = data.map(menu => {
        const children = menu.children && changeRespToRawMenu(menu.children);
        return Object.assign({}, menu, { path: menu.path, title: menu.name }, (children ? { children } : null));
    });
    return menuList;
}
export function createMenuData(data, resourcesArray, parents) {
    // 渲染菜单时先获取统一工作台的用户资源code, 若有此资源才展示对应的菜单；若菜单的资源code未配置，则仍展示菜单
    const filteredData = data.filter(menu => {
        const { resourceCode } = menu;
        return (!resourceCode ||
            (resourceCode &&
                _.findIndex(resourcesArray, ['code', resourceCode]) !== -1));
    });
    const menuData = filteredData.map(item => {
        if (/^https?:\/\//.test(item.path)) {
            return Object.assign({}, item, { path: item.path });
        }
        let path = `/${(parents || []).map(o => o.path).join('/')}/${item.path}`;
        path = path.replace(/\/+/g, '/');
        const children = item.children &&
            createMenuData(item.children, resourcesArray, [...(parents || []), item]);
        return Object.assign({}, item, { path }, (children ? { children } : null));
    });
    return menuData;
}
export function getUrlByPath(path, rawData) {
    const keys = path.split('/').filter(f => f);
    let data = rawData;
    let item = null;
    for (const key of keys) {
        let isFound = false;
        for (const menuItem of data) {
            if (menuItem.path === key) {
                isFound = true;
                item = menuItem;
                data = menuItem.children || [];
                break;
            }
        }
        if (!isFound) {
            return null;
        }
    }
    return item && item.url;
}
export function parseUrl(url) {
    const keys = [
        'href',
        'origin',
        'protocol',
        'host',
        'hostname',
        'port',
        'pathname',
        'search',
        'hash',
    ];
    let result = {};
    let i;
    const regexp = /(([^:]+:)\/\/(([^:\/\?#]+)(:\d+)?))(\/[^?#]*)?(\?[^#]*)?(#.*)?/;
    const match = regexp.exec(url);
    if (match) {
        // tslint:disable-next-line:no-increment-decrement
        for (i = keys.length - 1; i >= 0; --i) {
            result[keys[i]] = match[i] ? match[i] : '';
        }
    }
    return result;
}
export function addTimestampToUrlSearch(url) {
    const { origin, pathname, search, hash } = parseUrl(url);
    if (search) {
        if (search.includes('tofd')) {
            const oldTime = urlParams(search, 'tofd');
            const newTime = String(new Date().getTime());
            const newUrl = `${origin}${pathname}${search.replace(oldTime, newTime)}${hash}`;
            return newUrl;
        }
        else {
            const newUrl = `${origin}${pathname}${search}&${new Date().getTime()}${hash}`;
            return newUrl;
        }
    }
    else {
        const newUrl = `${origin}${pathname}?tofd=${new Date().getTime()}${hash}`;
        return newUrl;
    }
}
function handler(e) {
    if (e.data.url) {
        dispatch.router.replace({
            query: {
                url: e.data.url,
            },
        });
    }
}
export function addUrlListener() {
    window.addEventListener('message', handler);
}
export function removeUrlListener() {
    window.removeEventListener('message', handler);
}
export function urlParams(url, key) {
    const ret = url.match(new RegExp('(\\?|&)' + key + '=(.*?)(&|$)'));
    return ret && decodeURIComponent(ret[2]);
}
// 获取新功能提醒的消息
export const getNotifyCorrectMessage = (menuItem) => {
    const { notifyMessage, notifyStartDate, notifyExpireDate } = menuItem;
    if (!notifyMessage || !notifyStartDate || !notifyExpireDate)
        return '';
    const startTime = new Date(notifyStartDate).getTime();
    const endTime = new Date(notifyExpireDate).getTime();
    const currentTime = new Date().getTime();
    if (currentTime > startTime && currentTime < endTime) {
        return notifyMessage || '';
    }
    return '';
};
export const timeFormat = {
    dayFormat: 'yyyy-MM-DD',
    secondFormat: 'yyyy-MM-DD HH:mm:ss',
};
